import { render } from "./WhatIGetSheet.vue?vue&type=template&id=14f89af1&ts=true"
import script from "./WhatIGetSheet.vue?vue&type=script&lang=ts"
export * from "./WhatIGetSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__